var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavoritesPix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 95,
    viewBox: "0 0 99 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.596 22.4739C99.1059 19.9828 96.1495 18.0066 92.8957 16.6584C89.6418 15.3102 86.1542 14.6162 82.6321 14.6162C79.11 14.6162 75.6223 15.3102 72.3685 16.6584C69.1146 18.0066 66.1583 19.9828 63.6683 22.4739L58.5008 27.6414L53.3333 22.4739C48.3038 17.4444 41.4824 14.6188 34.3696 14.6188C27.2568 14.6188 20.4353 17.4444 15.4058 22.4739C10.3763 27.5034 7.55078 34.3248 7.55078 41.4376C7.55078 48.5504 10.3763 55.3719 15.4058 60.4014L20.5733 65.5689L58.5008 103.496L96.4283 65.5689L101.596 60.4014C104.087 57.9114 106.063 54.9551 107.411 51.7012C108.76 48.4474 109.453 44.9597 109.453 41.4376C109.453 37.9155 108.76 34.4279 107.411 31.174C106.063 27.9201 104.087 24.9638 101.596 22.4739Z",
    stroke: "#433F3F",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoritesPix);
export default __webpack_public_path__ + "static/media/favoritesPix.5910af95dab2ac5e39f52480826fd90f.svg";
export { ForwardRef as ReactComponent };